import React from 'react'
import styled from 'styled-components'
import GitHubIcon from "../github-mark-white.svg"
import LinkedInIcon from "../In-White-128@2x.png"

const Contact = () => {
  return (
    <ContactDetails>
    <a href='https://www.github.com/impregnablequestion' target='_blank' rel='noreferrer'>
      <img src={GitHubIcon} alt='GitHub' width={20}></img>
    </a>
    <a href='https://www.linkedin.com/in/seamuslouisryan' target='_blank' rel='noreferrer'>
      <img src={LinkedInIcon} alt='LinkedIn'width={20}></img>
    </a>
  </ContactDetails>
  )
}

const ContactDetails = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`

export default Contact